import { Button, styled } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { FunctionComponent } from 'react';
import { FlexContainer } from '@/components/Layout/Container';

const LangButton = styled(Button)(({ theme }) => ({
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.grey['200']}`,
    borderRadius: 0,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    display: 'flex',
    height: '28px',
    justifyContent: 'center',
    transition: 'all 250ms ease-out',
    width: 64,

    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.primary,
    },
}));

const getLangButtonProps = (isActive: boolean, theme: Theme) => ({
    color: isActive ? '#fff' : '#000',
    backgroundColor: isActive ? theme.palette.primary.main : '#fff',
    '&:hover': {
        backgroundColor: isActive
            ? theme.palette.primary.main
            : theme.palette.grey[200],
        color: isActive ? '#fff' : '#000',
    },
});

export const MultiLangAdornment: FunctionComponent<{
    currentLang: 'de' | 'en';
    onChangeLang: (nextLang: 'en' | 'de') => void;
    multiLine?: boolean;
}> = ({ onChangeLang, currentLang, multiLine }) => {
    const currentGerman = currentLang === 'de';
    return (
        <FlexContainer
            sx={{
                flexDirection: 'column',
                ...(multiLine && {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                }),
            }}
        >
            <LangButton
                sx={(theme) => ({
                    ...getLangButtonProps(currentGerman, theme),
                    borderTopRightRadius: '8px',
                })}
                onClick={() => {
                    onChangeLang('de');
                }}
                disableElevation
            >
                DE
            </LangButton>
            <LangButton
                sx={(theme) => ({
                    ...getLangButtonProps(!currentGerman, theme),
                    ...(multiLine && {
                        borderBottom: `1px solid ${theme.palette.grey[200]}`,
                    }),
                    borderBottomRightRadius: '8px',
                })}
                onClick={() => {
                    onChangeLang('en');
                }}
                disableElevation
            >
                EN
            </LangButton>
        </FlexContainer>
    );
};
